import PopupManager from 'element-ui/lib/utils/popup/popup-manager';

/** DraggableDialog z-index 从 10000 起，Element 下拉/弹层需高于弹窗 */
const DIALOG_Z_INDEX_GAP = 10;

let popupZIndexPatched = false;

/** 当前可见 DraggableDialog 遮罩的最大 z-index */
export function getDraggableDialogOverlayZIndex() {
    const dialogs = document.querySelectorAll('div[id^="draggable-dialog-"]');
    let zIndex = 0;
    for (const el of dialogs) {
        if (el.style.display === 'none') continue;
        const z = parseInt(el.style.zIndex, 10);
        if (!isNaN(z) && z > zIndex) zIndex = z;
    }
    return zIndex > 0 ? zIndex + DIALOG_Z_INDEX_GAP : undefined;
}

/** 将 Element PopupManager 基准抬到所有 DraggableDialog 之上 */
export function ensureElementPopupAboveDialogs() {
    const overlayZ = getDraggableDialogOverlayZIndex();
    if (overlayZ != null) {
        PopupManager.zIndex = Math.max(PopupManager.zIndex, overlayZ);
    }
}

/** 全局补丁：每次 Element 弹层分配 z-index 前先对齐 DraggableDialog */
export function installDialogPopupZIndexFix() {
    if (popupZIndexPatched) return;
    popupZIndexPatched = true;
    const originalNextZIndex = PopupManager.nextZIndex.bind(PopupManager);
    PopupManager.nextZIndex = function nextZIndexAboveDialog() {
        ensureElementPopupAboveDialogs();
        return originalNextZIndex();
    };
}

export function withDialogOverlayZIndex(options = {}) {
    const overlayZ = getDraggableDialogOverlayZIndex();
    if (!overlayZ) return options;
    if (!options.zIndex || options.zIndex < overlayZ) {
        return { ...options, zIndex: overlayZ };
    }
    return options;
}
